import React from "react";

const EmailCTA = () => {
  return (
    <div className="fade-page-animation">
      <div className="bg-dark-fade">
        <div className="centering">
          <div className="centering-cta">
            <h1 className="lets-create" style={{ margin: 0 }}>
              Let's create something together
            </h1>
            <button>
              <a href="mailto:hi@kadezaccaro.com">hi@kadezaccaro.com</a>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailCTA;
